import React from 'react';
import { Section } from '../Section';

/** Home · "Where we sit": the pre-flight / first-token diagram with Synthia on the seam. */
export function WhereWeSit() {
  return <Section label="Where we sit" contentClassName="wws-c" data-id="element-141" data-mp="1a376zuqy1s2r">
      <div className="hgroup" data-id="element-142" data-mp="1a1meeao6wj7j">
        <h2 className="h2 wws-h" data-id="element-143" data-mp="1a5jvyrv4d2pb">Between intent and the first token.</h2>
        <p className="lede" style={{
        maxWidth: 820
      }} data-id="element-144" data-mp="1f3lglh871a2w">
          Every AI request has a moment nobody governs: after a prompt is written or an agent is handed its directive, and before the model
          spends a single token. Synthia works in that moment. It gathers everything the answer has to honor, your regulations, your
          policies, your people’s judgment, and packages it into the request before the model starts. Not after, when the draft is back
          and the damage is done.
        </p>
      </div>

      <div className="wws" data-id="element-145" data-mp="22q1qopfxsnf6">
        <span className="wws-seam" aria-hidden="true" data-id="element-146" data-mp="27qg0od13m7fu" />

        <div className="wws-b l" data-id="element-147" data-mp="27ov4yk31sige">
          <div className="tag" data-id="element-148" data-mp="1ogp65x9jol4j">PRE-FLIGHT</div>
          <div className="t" data-id="element-149" data-mp="1oiju7kg44tcu">Intent</div>
          <p className="d" data-id="element-150" data-mp="1jhvxci57diap">
            A person writes a prompt. An agent picks up its directive. Neither knows the <strong data-id="element-151" data-mp="1eij5tk3dzn1s">complete</strong> set of obligations it
            must honor.
          </p>
          <div className="stk" data-id="element-152" data-mp="1ahh5ezxqh4y8">
            <span className="h" data-id="element-153" data-mp="1ai92ygaw5cr5">works here</span>
            <br data-id="element-154" data-mp="1ajk74h890mis" />
            prompt libraries · agent frameworks · orchestration
          </div>
        </div>

        <span className="wws-ar a1" aria-hidden="true" data-id="element-155" data-mp="228dnceynhzsd">
          →
        </span>

        <div className="wws-card" data-id="element-156" data-mp="22aq0metgrlz3">
          <div className="lb" data-id="element-157" data-mp="1xgvivgxf5h2n">SYNTHIA</div>
          <div className="st" data-id="element-158" data-mp="1xfu8leo88ylz">Every obligation (rule) that applies, composed into the request.</div>
          <div className="sb" data-id="element-159" data-mp="1tftj8yzlb305">Receipt issued before the first token.</div>
        </div>

        <span className="wws-ar a2" aria-hidden="true" data-id="element-160" data-mp="2pziwycdzzvu8">
          →
        </span>

        <div className="wws-b r" data-id="element-161" data-mp="2l6g2m21ecicz">
          <div className="tag" data-id="element-162" data-mp="2l55005jotgng">MODEL REASONING</div>
          <div className="t" data-id="element-163" data-mp="j9fpfpx8su0e">First token</div>
          <p className="d" data-id="element-164" data-mp="jbsc2gdy3sjs">The model starts generating. Search hands it what looks like the question. Synthia hands it what the answer must honor.</p>
          <div className="stk" data-id="element-165" data-mp="9knynl3x4fr2">
            <span className="h" data-id="element-166" data-mp="9jmb4h5pu0sg">works here · post-flight</span>
            <br data-id="element-167" data-mp="ei7bqhovqmhf" />
            RAG · knowledge graphs · semantic search · guardrails · evals
          </div>
        </div>
      </div>
    </Section>;
}